// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WON2","option":"styles_option__1IrMm","active":"styles_active__JKNbX"};